export default {
  namespaced: true,
  state: {
    // navbar 标题
    navBarTitle: ''
  },
  getters: {},
  mutations: {
    // 设置标题
    setNavBarTitle(state: any, payload: any) {
      state.navBarTitle = payload
    }
  },
  actions: {}
}
